export const enum ECommerceShoppingPlatform {
    WooCommerce = 'WooCommerce',
};

export const enum ECommerceOnboarding {
    Merchant = 'e',
    HighRiskMerchant = 'o'
};

export const enum ECommerceOnboardingApplicationStatus {
    Approved = 'approved',
    AwaitingReview = 'awaiting_review',
    Blocked = 'blocked',
    Idle = 'idle',
    NotStarted = 'not_started',
    InReview = 'in_review',
    RequestedChanges = 'requested_changes',
    Rejected = 'rejected',
    InProgress = 'in_progress'
};

export const enum ECommerceOnboardingApplicationStepAndFieldStatus {
    Approved = 'approved',
    AwaitingReview = 'awaiting_review',
    Rejected = 'rejected',
    RequestedChanges = 'requested_changes'
};

export const ECommerceOnboardingStep = {
    [ECommerceOnboarding.Merchant]: {
        GettingStarted: 0,
        BusinessInformation: 1,
        BankingAndFinance: 2,
        MediaAndComplianceCheck: 3,
        UBOIdentityVerification: 4,
        PaymentMethods: 5,
        CompleteOnboarding: 6
    },
    [ECommerceOnboarding.HighRiskMerchant]: {
        GettingStarted: 0,
        // TODO: Add steps for high-risk merchants
    }
};

export const PROOF_FILE = {
    maxSize: 10 * 1024 * 1024, // 10 MB
    supportedFormats: [
        'image/png',
        'image/jpeg',
        'application/pdf',
        'application/vnd.ms-excel', // XLS
    ]
};

export const enum SupportedPaymentMethodsTag {
    Bancontact = 'bancontact',
    Blik = 'blik',
    Eps = 'eps',
    Giropay = 'giropay',
    Ideal = 'ideal',
    Mbway = 'mbway',
    Klarna = 'klarna',
    P24 = 'p24'
};

export const supportedPaymentMethods = {
    [SupportedPaymentMethodsTag.Bancontact]: {
        displayName: 'Bancontact',
        imageUrl: '/assets/images/payment-methods/bancontact.png',
        tag: SupportedPaymentMethodsTag.Bancontact,
    },
    [SupportedPaymentMethodsTag.Blik]: {
        displayName: 'Blik',
        imageUrl: '/assets/images/payment-methods/blik.png',
        tag: SupportedPaymentMethodsTag.Blik,
    },
    [SupportedPaymentMethodsTag.Eps]: {
        displayName: 'EPS',
        imageUrl: '/assets/images/payment-methods/eps.png',
        tag: SupportedPaymentMethodsTag.Eps,
    },
    [SupportedPaymentMethodsTag.Giropay]: {
        displayName: 'Giropay',
        imageUrl: '/assets/images/payment-methods/giropay.png',
        tag: SupportedPaymentMethodsTag.Giropay,
    },
    [SupportedPaymentMethodsTag.Ideal]: {
        displayName: 'iDEAL',
        imageUrl: '/assets/images/payment-methods/ideal.png',
        tag: SupportedPaymentMethodsTag.Ideal,
    },
    [SupportedPaymentMethodsTag.Mbway]: {
        displayName: 'MB WAY',
        imageUrl: '/assets/images/payment-methods/mbway.png',
        tag: SupportedPaymentMethodsTag.Mbway,
    },
    [SupportedPaymentMethodsTag.Klarna]: {
        displayName: 'Klarna',
        imageUrl: '/assets/images/payment-methods/klarna.png',
        tag: SupportedPaymentMethodsTag.Klarna,
    },
    [SupportedPaymentMethodsTag.P24]: {
        displayName: 'P24',
        imageUrl: '/assets/images/payment-methods/p24.png',
        tag: SupportedPaymentMethodsTag.P24,
    }
};

export const enum ECommerceOnboardingFilableResource {
    BillingFinanceSteps = 'billing-finance-steps',
    UboIdentities = 'ubo-identities',
    ClientDocumentsSteps = 'client-documents-steps'
};
